import request from '@/shared/api/request';

export const enableDatabaseBackups = (uuid: string): Promise<void> =>
  request({
    url: `/databases/${uuid}/`,
    method: 'POST',
    data: { action: 'enable_backups' },
  });
